import {Component, Input} from '@angular/core';

/**
 * Component that just displays an animated cross icon
 */
@Component({
  selector: 'app-animated-cross',
  templateUrl: './animated-cross.component.html',
  styleUrls: ['./animated-cross.component.scss'],
  imports: [],
})
export class AnimatedCrossComponent {
  @Input() color: string = '';
}
